<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="calories"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Χρεώσεις</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" v-bind:disabled="addButtonDisabled">
                ΔΗΜΙΟΥΡΓΙΑ
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12" sm="6">
                      <v-text-field
                        full-width
                        v-model="editedItem.description"
                        label="Περιγραφή χρέωσης"
                        v-bind:error-messages="allerrors.description"
                      />
                      
                      <v-select
                        clearable
                        label="Κατηγορία χρέωσης"
                        v-model="editedItem.category_id"
                        v-bind:items="chargeCategories"
                        item-text="name"
                        item-value="id"
                        v-bind:error-messages="allerrors.category_id"
                      />

                      <v-select
                        clearable
                        label="Κατηγορία ΦΠΑ"
                        placeholder="(Δεν αντιστοιχεί)"
                        v-model="editedItem.vat_category_id"
                        v-bind:items="vatCategories"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.vat_category_id"
                      />
                      <v-select
                        clearable
                        label="Κατηγορία εξαίρεσης ΦΠΑ"
                        placeholder="(Δεν αντιστοιχεί)"
                        v-model="editedItem.vat_exemption_category_id"
                        v-bind:items="vatExemptionCategories"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.vat_exemption_category_id"
                      />

                      <v-select
                        clearable
                        label="Κατηγορία παρακράτησης φόρου"
                        placeholder="(Δεν αντιστοιχεί)"
                        v-model="editedItem.tax_withholding_category_id"
                        v-bind:items="taxWithholdingCategories"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.tax_withholding_category_id"
                      />

                      <v-select
                        clearable
                        label="Κατηγορία εσόδου"
                        v-model="editedItem.income_category_id"
                        v-bind:items="incomeCategories"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.income_category_id"
                      />

                      <v-select
                        clearable
                        label="Τύπος εσόδου λιανικής (GR)"
                        v-model="editedItem.incomeClassificationGRretail.id"
                        v-bind:items="incomeClassifications"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.income_classification_gr_retail_id"
                      />

                      <v-select
                        clearable
                        label="Τύπος εσόδου χονδρικής (GR)"
                        v-model="editedItem.incomeClassificationGR.id"
                        v-bind:items="incomeClassifications"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.income_classification_gr_id"
                      />

                      <v-select
                        clearable
                        label="Τύπος εσόδου (EU)"
                        v-model="editedItem.incomeClassificationEU.id"
                        v-bind:items="incomeClassifications"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.income_classification_eu_id"
                      />

                      <v-select
                        clearable
                        label="Τύπος εσόδου (INT)"
                        v-model="editedItem.incomeClassificationINT.id"
                        v-bind:items="incomeClassifications"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.income_classification_int_id"
                      />

                      
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.description }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Περιγραφή',
          align: 'start',
          //sortable: false,
          value: 'description',
        },
        {
          text: 'Κατηγορία',
          value: 'category.name'
        },
        { 
          text: 'Κατηγορία ΦΠΑ', 
          value: 'vatCategory.description' 
        },
        { 
          text: 'Κατηγορία εσόδου', 
          value: 'incomeCategory.description' 
        },
        /*
        { 
          text: 'Κατηγορία εξαίρεσης ΦΠΑ', 
          value: 'vatExemptionCategory.description'
        },
        { 
          text: 'Τύπος εσόδου (GR)', 
          value: 'incomeClassificationGR.description' 
        },
        { 
          text: 'Τύπος εσόδου (EU)', 
          value: 'incomeClassificationEU.description' 
        },
        { 
          text: 'Τύπος εσόδου (INT)', 
          value: 'incomeClassificationINT.description' 
        },
        */
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      vatCategories: [],
      incomeClassifications: [],
      incomeCategories: [],
      chargeCategories: [],
      chargeTypes: [],
      vatExemptionCategories: [],
      taxWithholdingCategories: [],

      allerrors: {},
      editedIndex: -1,
      editedItem: {
        description: '',
        vat_category_id: '',
        income_category_id: '',
        income_classification_id: '',
        vat_exemption_category_id: '',
        incomeClassificationGRretail: {},
        incomeClassificationGR: {},
        incomeClassificationEU: {},
        incomeClassificationINT: {},
        tax_withholding_category_id: {},
      },
      defaultItem: {
        description: '',
        vat_category_id: '',
        income_category_id: '',
        income_classification_id: '',
        vat_exemption_category_id: '',
        incomeClassificationGR: {},
        incomeClassificationGRretail: {},
        incomeClassificationEU: {},
        incomeClassificationINT: {},
        tax_withholding_category_id: {},
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false,
      addButtonDisabled: true
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {

      mixmatch(chargeType) {
        chargeType.vatCategory = this.vatCategories.find(vatCategory => vatCategory.id == chargeType.vat_category_id)
        chargeType.incomeClassificationGR = this.incomeClassifications.find(incomeClassification => incomeClassification.id == chargeType.income_classification_gr_id)
        chargeType.incomeClassificationGRretail = this.incomeClassifications.find(incomeClassification => incomeClassification.id == chargeType.income_classification_gr_retail_id)
        chargeType.incomeClassificationEU = this.incomeClassifications.find(incomeClassification => incomeClassification.id == chargeType.income_classification_eu_id)
        chargeType.incomeClassificationINT = this.incomeClassifications.find(incomeClassification => incomeClassification.id == chargeType.income_classification_int_id)
        chargeType.incomeCategory = this.incomeCategories.find(incomeCategory => incomeCategory.id == chargeType.income_category_id)
        chargeType.vatExemptionCategory = this.vatExemptionCategories.find(vatExemptionCategory => vatExemptionCategory.id == chargeType.vat_exemption_category_id)
        chargeType.taxWithholdingCategory = this.taxWithholdingCategories.find(taxWithholdingCategory => taxWithholdingCategory.id == chargeType.tax_withholding_category_id)
        chargeType.category = this.chargeCategories.find(category => category.id == chargeType.category_id)

        return chargeType
      },

      initialize () {
        
        axios.all([
          axios.get('/api/tax-authority/vat-categories'),
          axios.get('/api/tax-authority/income-classifications'),
          axios.get('/api/tax-authority/income-categories'),
          axios.get('/api/tax-authority/vat-exemption-categories'),
          axios.get('/api/tax-authority/tax-withholding-categories'),
          axios.get('/api/charge-categories'),
          axios.get('/api/charge-types')
        ]).then(axios.spread((
          vatCategoriesResponse, 
          incomeClassificationsResponse, 
          incomeCategoriesResponse, 
          vatExemptionCategoriesResponse, 
          taxWithholdingCategoriesResponse,
          chargeCategoriesResponse,
          chargeTypesResponse
        ) => {
          this.vatCategories = vatCategoriesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
          this.incomeClassifications = incomeClassificationsResponse.data.sort((a, b) => a.description.localeCompare(b.description))
          this.incomeCategories = incomeCategoriesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
          this.chargeTypes = chargeTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
          this.vatExemptionCategories = vatExemptionCategoriesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
          this.taxWithholdingCategories = taxWithholdingCategoriesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
          this.chargeCategories = chargeCategoriesResponse.data.sort((a, b) => a.name.localeCompare(b.name))

          this.chargeTypes.map(chargeType =>  this.mixmatch(chargeType))

          this.items = this.chargeTypes


          this.defaultItem.income_category_id = this.incomeCategories.find(x => x.tax_authority_code == 'category1_3').id
          this.defaultItem.incomeClassificationINT = this.incomeClassifications.find(x => x.tax_authority_code == 'E3_561_006')
          this.defaultItem.incomeClassificationEU = this.incomeClassifications.find(x => x.tax_authority_code == 'E3_561_005')
          this.defaultItem.incomeClassificationGR = this.incomeClassifications.find(x => x.tax_authority_code == 'E3_561_001')
          this.defaultItem.incomeClassificationGRretail = this.incomeClassifications.find(x => x.tax_authority_code == 'E3_561_003')
          this.defaultItem.vat_category_id = this.vatCategories.find(x => x.tax_authority_code == '1').id

          if (this.chargeCategories.length == 1)
            this.defaultItem.category_id = this.chargeCategories[0].id

          this.addButtonDisabled = false;

        })).catch(error => { console.log(error) })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true
        axios.delete(`/api/charge-types/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {

        this.saveButtonDisabled = true

        let requestBody = {
          description: this.editedItem.description, 
          category_id: this.editedItem.category_id,
          vat_category_id: this.editedItem.vat_category_id,
          vat_exemption_category_id: this.editedItem.vat_exemption_category_id,
          income_category_id: this.editedItem.income_category_id,
          income_classification_gr_id: this.editedItem.incomeClassificationGR.id,
          income_classification_gr_retail_id: this.editedItem.incomeClassificationGRretail.id,
          income_classification_eu_id: this.editedItem.incomeClassificationEU.id,
          income_classification_int_id: this.editedItem.incomeClassificationINT.id,
          tax_withholding_category_id: this.editedItem.tax_withholding_category_id,
        }

        // console.log(requestBody)

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/charge-types/${this.editedItem.id}`, requestBody)
          .then(response => { Object.assign(this.items[this.editedIndex], this.mixmatch(response.data)); this.close(); })
          .catch(error => { console.log(error) })
          .finally(() => this.saveButtonDisabled = false)
          
        } else {

          axios.post('/api/charge-types', requestBody)
          .then(response => { 
            this.items.push(this.mixmatch(response.data)); 
            this.allerrors = {}
            this.close();
          })
          .catch(error => {
            console.log(error.response)

            this.allerrors = error.response.data.errors
          })
          .finally(() => this.saveButtonDisabled = false)
        }
      },
    },
  }
</script>

<style scoped>
</style>